import createReactComponent from '../createReactComponent';
export default createReactComponent('frame-off', 'IconFrameOff', [
  ['path', { d: 'M4 7h3m4 0h9', key: 'svg-0' }],
  ['path', { d: 'M4 17h13', key: 'svg-1' }],
  ['path', { d: 'M7 7v13', key: 'svg-2' }],
  ['path', { d: 'M17 4v9m0 4v3', key: 'svg-3' }],
  ['path', { d: 'M3 3l18 18', key: 'svg-4' }],
]);
